import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'


class DetailBloc {

    detailDateChannel = new Subject();
    repository = new DetailRepository()

    constructor() {
        this.detailDateChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetailDate = async (query) => {
        try {
            this.detailDateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetailDate(query).then((result) => {
                this.detailDateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailDateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
}

export default DetailBloc